export default {
    authTokenBM: 'oauth/token',
    property: 'api/property',
    account: '/api/account/{id}',
};
